import { REFERENCE_TYPE_SERVICE_NAME } from "../../../services/reference-type"
import { GRID_SERVICE_NAME } from "../../../services/grid"
import { USER_SESSION_SERVICE_NAME } from "../../../services/user-session"
import { DISTRIBUTOR_HIERARCHY_SERVICE_NAME } from "../../../services/distributor"
import { DATA_TYPE_GROUP_SERVICE_NAME } from "../../../services/data-type-group"
import { IMRBaseComponent } from "../base"
import { DropDownBoxController } from "./drop-down-box.controller"

//#region Asset Imports

import './drop-down-box.scss'
import * as TEMPLATE from './drop-down-box.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'dropDownBox'

export class DropDownBoxComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: DropDownBoxController,
            services: [USER_SESSION_SERVICE_NAME, GRID_SERVICE_NAME, REFERENCE_TYPE_SERVICE_NAME, DISTRIBUTOR_HIERARCHY_SERVICE_NAME, DATA_TYPE_GROUP_SERVICE_NAME],
            template: TEMPLATE
        })
    }
}